import styled from 'styled-components';

export const StyledTotalInfo = styled.div`
  position: absolute;
  left: 20px;
  top: 20px;
  color: var(--color-text-main);
  padding: 10px;
  background-color: #ffffff;

  border: 2px solid #0b95c3;
  box-shadow: 0px 1px 5px 0px #92c3ff66;
  width: 270px;
  border-radius: 8px;

  display: flex;
  flex-direction: column;

  .main-item {
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid #92c3ff4d;
    padding: 10px;
    cursor: pointer;
  }

  .main-item span {
    font-size: 18px;
    font-weight: 500;
    color: #055cb4;
  }

  .sub-item {
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid #92c3ff4d;
    padding: 10px;
    cursor: pointer;
  }

  .sub-item .title {
    display: flex;
    gap: 10px;
    align-items: center;
  }

  .sub-item:last-child {
    border-bottom: none !important;
  }

  .sub-item span {
    font-size: 16px;
    font-weight: 500;
    color: #585959;
  }
`;
